export enum AUDIENCE_ID {
  STUDENT = 1,
  LEGAL_REPRESENTATIVE = 2,
  TEACHER = 3,
  OO_ADMIN = 4,
  OO_GROUPS_ADMIN = 5,
}
